module.exports = __webpack_public_path__ + "img/wjgx2.14619f30.png";